import { AutopayTermsConditionsComponent } from '../../../common/autopay-terms-conditions/autopay-terms-conditions.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { ManageAutopayImpNoticeComponent } from '../../../dashboard/loggedin-content/imp-notice/manage-autopay-imp-notice/manage-autopay-imp-notice.component';
import { ImpNoticeComponent } from '../../../dashboard/loggedin-content/imp-notice/imp-notice.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, HostListener, Output, EventEmitter, NO_ERRORS_SCHEMA, ViewChild } from '@angular/core';
import { FormGroup, FormControl, ValidatorFn, AbstractControl, ValidationErrors, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, Params, RouterModule } from '@angular/router';
import {
  AlertService,
  FormBase,
  FormBaseControlService,
  GTagService,
  ModalOptions,
  AcmicService,
  Select,
} from '@mapfre-design-library/src/public_api';
import { PaperlessService } from '../../../../_services/_iam/paperless.service';
import { PolicyDetailsService } from '../../../../_services/my-insurance/policy-details.service';
import { StorageServiceObservablesService } from '../../../../_services/storage-service-observables/storage-service-observables.service';
import { BankAccountService } from '../../../../_services/profile-settings/bank-account.service';
import { PolicyDataService } from '../../../../_services/data-services/policy-data.service';
import { BillingDataService } from '../../../../_services/data-services/billing-data.service';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { TranslateService } from '@ngx-translate/core';
import { Capacitor } from '@capacitor/core';
import { AppRatingService } from '../../../../_services/pwa-service/app-rating.service';
import { CustomerProfileService } from '../../../../_services/customer-profile/customer-profile.service';
import { } from '@angular/common';
import { Constants } from '@models/constants';
import { AutopayBillingService } from '../../../../_services/my-insurance/autopay-billing.service';
import { EnrollEftEpayService } from '@services/forms/enroll-eft-epay/enroll-eft-epay.service';
import { InfoTooltipComponent } from '../../../common/info-tooltip/info-tooltip.component';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ImpNoticeComponent, ManageAutopayImpNoticeComponent, MapfreIputWithValidationComponent, MapfreButtonComponent, MapfreModalComponent, AutopayTermsConditionsComponent, InfoTooltipComponent],
  selector: 'app-enroll-eft-epay-form',
  templateUrl: './enroll-eft-epay-form.component.html',
  providers: [FormBaseControlService],
})
export class EnrollEftEpayFormComponent implements OnInit {
  @Input() inputs: FormBase<any>[] = [];
  @Input() userData: any;
  @Output() showTermsConditionsEvent: EventEmitter<any> = new EventEmitter();
  topicDropdownHeight: number;
  hoveredIndex: number = null;
  hoveredTopicIndex: number = null;
  deductionDateOptions: any[];
  accountType: string;
  deducDate = '';
  currBankAcc = '';
            enrollInEft:              FormGroup;
            enrollAccountType:        FormGroup;
            loading = false;
            policyDetails:            any;
            policyId:                 string;
            email:                    any;
            isDeductionDateDisabled = false;
            bankAccountNumber:        any;
            storeBankAccount:         any;
            isDeductionDateValid:     any;
            storeCheck = false;
            loader = false;
            showEnrollInfoConfirm: boolean;
            hideModal: boolean;
            enrollConfirmModalOptions: ModalOptions;
            impText: string;
            mode: string;
            impText2: string;
            minAmountDue: string;
            billedWithdrawalDate: string;
            plannedWithdrawalDate: string;
            billedInvoice = false;
            newDeductionDay: string;
            isAcmic: boolean;
            company: string
  withdrawalDueDate: number;
  importantText: string;
  importantAchEftText: string;
  impNoticeDetails: Record<string, unknown>;
  isTermsAndCondReview: boolean;
  showTermsConditions: boolean;
  iconWarning: string;
  isDeductionDateDisabledPayPlan = false
  isMobile = false;
  @ViewChild('deductionTooltip') deductionTooltip?: InfoTooltipComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private billingDataService: BillingDataService,
    private bankAccountService: BankAccountService,
    private ipt: FormBaseControlService,
    public router: Router,
    private paperlessService: PaperlessService,
    private policyDataService: PolicyDataService,
    private policyDetailsService: PolicyDetailsService,
    private storageService: StorageServiceObservablesService,
    private errorRedirectionService: ErrorRedirectionService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private appRatingService: AppRatingService,
    private customerProfileService: CustomerProfileService,
    private autopayBillingService: AutopayBillingService,
    private acmicService: AcmicService,
    private eftService: EnrollEftEpayService
  ) {
    this.showEnrollInfoConfirm = false;
    this.enrollConfirmModalOptions = new ModalOptions({
      additionalClasses: 'autopay-modal modal-center-on-page modal-dialog modal-dialog-scrollable modal-medium upload-document-modal',
      additionalButtonClasses: 'ghost ml-2 x-small-btn',
      animatePosition: 'center',
      modalId: 'enrollConfirmModal',
      modalTranslateCopy: '',
      typeOfModal: 'default',
      modalName: 'autopay_enroll_confirm',
      onLoad: true,
    });
  }

  @HostListener('window:keyup', ['$event'])
  OnKeyUpGlobal(event) {
    this.checkMaskValue(event);
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobile = window.innerWidth < 768;
  }

  @HostListener('document:click')
  onDocClick() {
    this.deductionTooltip?.hide();
  }

   toggleDeductionTooltip(event: Event) {
    event.stopPropagation();
    this.deductionTooltip?.toggle();
  }

  checkMaskValue(event) {
    if (event.target.id == 'enrollInEft_accountNumber') {
      if (this.MatchMaskValue(event.target.value)) {
        this.enrollInEft.controls['enrollInEft_accountNumber']?.setValue('');
        this.enrollInEft.controls['enrollInEft_confirmAccountNumber']?.setValue(
          ''
        );
        this.enrollInEft.controls['enrollInEft_accountNumber'].setErrors({
          invalidAccount: true,
        });
      }
    }
    if (event.target.id == 'enrollInEft_confirmAccountNumber') {
      if (this.MatchMaskValue(event.target.value)) {
        this.enrollInEft.controls['enrollInEft_confirmAccountNumber']?.setValue(
          ''
        );
        this.enrollInEft.controls['enrollInEft_confirmAccountNumber']?.setErrors(
          { invalidConfirmAccount: true }
        );
      }
    }
  }

  MatchMaskValue(val) {
    if (
      val.match('X') ||
      val.match('XX') ||
      val.match('XXX') ||
      val.match('XXXX')
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkForPrefillData(eftData): void {
    const bankDetails = eftData || '';
    if (bankDetails != '') {
      this.enrollInEft.patchValue({
        enrollInEft_accountName: bankDetails.accountName,
        enrollInEft_accountNumber: bankDetails.bankAccount
          ? 'XXXX' +
          bankDetails.bankAccount.substring(
            bankDetails.bankAccount.length - 4,
            bankDetails.bankAccount.length
          )
          : '',
        enrollInEft_routingNumber: bankDetails.abaCode,
        enrollInEft_confirmAccountNumber: bankDetails.bankAccount
          ? 'XXXX' +
          bankDetails.bankAccount.substring(
            bankDetails.bankAccount.length - 4,
            bankDetails.bankAccount.length
          )
          : '',
      });

      if (this.router.url.includes(Constants.EDIT_ENROLL)) {
        if (bankDetails.deductionDay) {
          this.isDeductionDateValid = true;
        }
        this.enrollInEft.patchValue({
          enrollInEft_deductionDate: +bankDetails.deductionDay,
        });
        this.deducDate = bankDetails.deductionDay;
        this.currBankAcc = this.enrollInEft.controls['enrollInEft_accountNumber'].value;
      }
    }
  }

  onDeductionDateChange(e) {
    void e;
    this.isDeductionDateValid = true;
  }

  onDeductionDateClose(event: any) {
    void event;
    if (!this.enrollInEft.controls['enrollInEft_deductionDate'].value)
      this.hoveredTopicIndex = null;
    this.topicDropdownHeight = 24;//top margin
  }

  onDeductionDateOpen(event: any) {
    void event;
    if (this.isAcmic)
      this.topicDropdownHeight += Math.min(159, this.deductionDateOptions.length * 24);//+ top margin
    else
      this.topicDropdownHeight += Math.min(160, this.deductionDateOptions.length * 40);//+ top margin
  }

  onTermsConditionsClick() {
    this.showTermsConditions = true;
    this.showTermsConditionsEvent.emit(true);
  }

  onHideTermsConditions(event: boolean) {
    this.isTermsAndCondReview = true;
    this.showTermsConditions = event;
    this.showTermsConditionsEvent.emit(event);
  }

  mapAccountType(accountType: string) {
    if (this.policyId.length === 10) {
      return accountType + 'L';
    } else {
      return accountType;
    }
  }

  setDayText(deductionDay) {
    if (deductionDay === '01' || +deductionDay === 1) {
      return '1st';
    } else if (deductionDay === '02' || +deductionDay === 2) {
      return '2nd';
    } else if (deductionDay === '03' || +deductionDay === 3) {
      return '3rd';
    } else if (+deductionDay < 10) {
      return `${+deductionDay % 10}th`;
    } else {
      return `${deductionDay}th`;
    }
  }
  isDeductionDayChanged() {
    this.newDeductionDay =
      this.enrollInEft.controls['enrollInEft_deductionDate'].value;
    return +this.deducDate === +this.newDeductionDay;
  }
  openEnrollConfirmModal() {
    this.showEnrollInfoConfirm = true;
    this.impNoticeDetails = {
      policy: this.policyDetails[0],
      accountNum: this.enrollInEft.controls['enrollInEft_accountNumber'].value,
      currAccountNum: this.currBankAcc,
      deductionDay: this.enrollInEft.controls['enrollInEft_deductionDate'].value,
      currDeductionDay: this.deducDate
    }

    const editImpNotice = this.eftService.getImportantEditNotice(this.impNoticeDetails);
    this.impText = editImpNotice?.editImpNotice;
  }

  enroll(email, policyid, mode?) {
    if (this.mode === 'edit' && !mode) {
      this.openEnrollConfirmModal();
      return;
    }
    this.showEnrollInfoConfirm = false;
    if (
      this.enrollInEft.controls['enrollInEft_accountNumber'].value !=
      this.enrollInEft.controls['enrollInEft_confirmAccountNumber'].value
    ) {
      this.gTagService.triggerFormLink(
        'enrollInEft',
        'false',
        this.translate.instant('ACCCOUNT_AND_CONFIRM_NUMBER_MATCH')
      );
      this.alertService.error(
        'Account number and Confirmation are not the same'
      );
      return;
    }
    let temAccount = '';
    if (
      this.MatchMaskValue(
        this.enrollInEft.controls['enrollInEft_accountNumber'].value
      )
    ) {
      temAccount = this.storeBankAccount;
    } else {
      temAccount = this.enrollInEft.controls['enrollInEft_accountNumber'].value;
    }
    const accountName = this.enrollInEft.controls['enrollInEft_accountName'].value;
    const bankName = (this.enrollInEft.controls['enrollInEft_bankName'])
      ? this.enrollInEft.controls['enrollInEft_bankName'].value
      : "";
    const enrollForm = {
      bankAccount: {
        accountHolderName: accountName != '' ? accountName.trim() : accountName,
        bankName: bankName.trim(),
        routingNumber: {
          digits: this.enrollInEft.controls['enrollInEft_routingNumber'].value,
        },
        accountNumber: {
          digits: temAccount,
        },
        accountType: this.mapAccountType(
          this.enrollAccountType.controls['bankType'].value
        ),
        mailingAddress: {
          streetName: this.policyDetails[0].mailingAddress && this.policyDetails[0].mailingAddress.streetName ? this.policyDetails[0].mailingAddress.streetName : '',
          city: this.policyDetails[0].mailingAddress && this.policyDetails[0].mailingAddress.city ? this.policyDetails[0].mailingAddress.city : '',
          state: this.policyDetails[0].mailingAddress && this.policyDetails[0].mailingAddress.state ? this.policyDetails[0].mailingAddress.state : '',
          zipCode: {
            code: this.policyDetails[0].mailingAddress && this.policyDetails[0].mailingAddress.zipCode.code ? this.policyDetails[0].mailingAddress.zipCode.code : '',
          }
        }
      },
      checkNumber: '',
      paymentAmount: '',
      deductionDay: (this.enrollInEft.controls['enrollInEft_deductionDate'])
        ? this.enrollInEft.controls['enrollInEft_deductionDate'].value : ""
    };
    this.loader = true;
    if (this.router.url.includes(Constants.EDIT_ENROLL)) {
      this.paperlessService.setCurrentRoute('/edit-enroll');
      this.paperlessService
        .updatePaperlessEPayV2(this.policyDetails[0], enrollForm, email)
        .subscribe(() => {
          if (this.company === 'ACIC' || this.company === 'TW') {
            this.handleEpaySuccess(enrollForm, policyid);
          } else {
            this.autopayBillingService.setWithdrawalData({ oldDeductionDay: this.setDayText(this.deducDate), newDeductionDay: this.setDayText(this.newDeductionDay), withdrawalDate: this.billedWithdrawalDate ? this.billedWithdrawalDate : this.plannedWithdrawalDate });
            this.handleEpaySuccess(enrollForm, policyid, 'edit');
          }
        },
          (error) => {
            this.handleErrors(error);
          });
    }
    else {
      this.paperlessService.setCurrentRoute('/enroll');
      this.paperlessService
        .enrollPaperlessEPayV2(this.policyDetails[0], enrollForm, email)
        .subscribe(() => {
          this.handleEpaySuccess(enrollForm, policyid);
          if (Capacitor.isNativePlatform()) {
            this.appRatingService.rateApp();
          }
        },
          (errordata) => {
            this.handleErrors(errordata);
          });
    }
  }

  handleErrors(errordata) {
    this.gTagService.triggerFormLink(
      'enrollInEft',
      'false',
      this.translate.instant('ENROLL_ERROR')
    );
    this.loader = false;
    if (errordata.status === 500 || errordata.status === 403) {
      const errorMessage = errordata.error?.message
      if (errorMessage && errorMessage === "02")
        this.alertService.error('Provide a valid account or routing number.', true);
      else
        this.alertService.error('ROUTING_NUMBER_VALIDATION', true);
    } else {
      this.errorRedirectionService.redirect(errordata.status);
    }
  }

  handleEpaySuccess(enrollForm, policyid, mode?) {
    this.gTagService.triggerFormLink('enrollInEft', 'true', '');
    this.loader = false;
    this.billingDataService.updateBillingDetails(enrollForm);
    this.reSync(policyid);
    if (policyid.length === 10) {
      this.customerProfileService.setModalTitle('AUTOPAY');
    }
    if (mode === 'edit') {
      this.router.navigate(['/billing/' + policyid + '/payment-info-updated'], {
        state: { impNoticeDetails: this.impNoticeDetails }
      });
    } else if (mode === 'no-change-in-deduction-day') {
      this.router.navigate(
        ['/billing/paperless/e-pay/' + policyid + '/confirm'],
        { queryParams: { mode: 'edit-confirm' } }
      );
    } else {
      this.router.navigate([
        '/billing/paperless/e-pay/' + policyid + '/confirm',
      ]);
    }
  }

  getStore(e): void {
    if (e.target.checked) {
      this.storeCheck = true;
    } else {
      this.storeCheck = false;
    }
  }

  onCheckboxClick(event: MouseEvent) {
    if (!this.isTermsAndCondReview) {
      event.preventDefault();
      event.stopPropagation();
      return
    }
  }

  reSync(policyNumber: string): void {
    this.loading = true;
    this.policyDataService.clear();
    this.policyDetailsService
      .getPolicyDetailsByEmail(this.storageService.getUserFromStorage())
      .subscribe(
        () => {
          this.policyDataService.$policyDetails
            .subscribe((policyResponse) => {
              if (policyResponse && policyResponse.length > 0) {
                const policy = policyResponse.find((response) => response.policynumber.policyNumber === policyNumber);
                if (policy?.company?.companyName === 'TW' || policy?.company?.companyName === 'ACIC') {
                  policy.policyFlags.isEft = 'ENROLLMENT-PENDING'
                }
              }
            });
          this.loading = false;
        },
        (error) => {
          this.errorRedirectionService.errorRedirectHandler(error);
        }
      );
  }
  getDataForNotice(policy) {
    if (policy.scheduleBills) {
      policy.scheduleBills.filter((scheduledBill) => {
        if (scheduledBill.invoiceState === 'Billed') {
          this.billedInvoice = true;
          this.billedWithdrawalDate = scheduledBill.dateDue;
          this.minAmountDue = scheduledBill.minAmountDue;
          this.withdrawalDueDate = this.policyDetailsService.getDayDifference(this.billedWithdrawalDate);
        }
      });
      const sortedPlannedBills =
        this.autopayBillingService.getSortedPlannedBills(policy);
      this.plannedWithdrawalDate =
        sortedPlannedBills && sortedPlannedBills.length > 0 &&
        sortedPlannedBills[0].length &&
        sortedPlannedBills[0].dateDue;
    }
  }
  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.isMobile = window.innerWidth < 768;
    this.iconWarning = this.isAcmic 
                          ? "./assets/img/images/icon-warning-black-acmic.svg" 
                          : "./assets/img/images/icon-warning-black-ma.svg"
    this.topicDropdownHeight = 24;
    this.loading = true;
    this.initFormGroups();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });

    this.policyDataService.$policyDetails.subscribe((policyResponse) => {
      if (policyResponse && policyResponse.length > 0) {
        this.policyDetails = policyResponse.filter((response) => response.policynumber.policyNumber === this.policyId);
        if (this.policyDetails[0]) {  
          if(this.policyDetails[0].isSimplifiedPayPlan){
            this.enrollInEft.controls['enrollInEft_deductionDate']?.disable();
            this.enrollInEft.controls['enrollInEft_deductionDate']?.setValue(
                  Math.min(new Date(this.policyDetails[0].effDate + "T00:00:00").getDate(), 28)
                );
            this.isDeductionDateDisabledPayPlan = true;
          }
          this.company = this.policyDetails[0].company.companyName
          this.getDataForNotice(this.policyDetails[0]);
          if (this.policyDetails[0].policyFlags.allowDeductionDateChange === 'N' && this.router.url.includes(Constants.EDIT_ENROLL)) {
            this.enrollInEft.controls['enrollInEft_deductionDate']?.disable();
            this.isDeductionDateDisabled = true;
          } else if (
            this.policyDetails[0].policyFlags.allowDeductionDateChange ===
            'N' &&
            !this.router.url.includes(Constants.EDIT_ENROLL)
          ) {
            this.enrollInEft.controls['enrollInEft_deductionDate']?.setValue(1);
            this.enrollInEft.controls['enrollInEft_deductionDate']?.disable();
            this.isDeductionDateDisabled = true;
          }

          this.setImpNotice();
        }
      }
    });
    this.email = this.storageService.getUserFromStorage();

    if (this.router.url.includes(Constants.EDIT_ENROLL) && this.company !== 'ACIC' && this.company !== 'TW') {
      this.mode = "edit";
    } else {
      this.mode = this.router.url.includes(Constants.EDIT_ENROLL) ? "edit-acic-tw" : "enroll-add";
    }

    this.setBankType();
    this.inputs.filter((input): input is Select => (input.inputType === 'select'))
      .map(select => this.mapDeductionDate(select.options))
  }

  resetHideModal(event): void {
    this.showEnrollInfoConfirm = false;
    if (event) {
      this.hideModal = !this.hideModal;
    }
  }
  hideModalAction(event): void {
    this.resetHideModal(event);
  }

  private initFormGroups() {
    this.enrollInEft = this.ipt.toFormGroup(this.inputs);
    this.enrollInEft.setValidators(this.matchValidator);
    this.enrollInEft.updateValueAndValidity();
    this.enrollInEft.controls['enrollInEft_deductionDate']?.setValue(null);
    this.enrollAccountType = new FormGroup({
      bankType: new FormControl(''),
    });
  }

  private setBankType() {
    if (this.mode === "edit") {
      this.bankAccountService
        .getBankInformation(this.policyId)
        .subscribe((bankDetail) => {
          if (
            bankDetail['accountType'] === '' ||
            bankDetail['accountType'] === 'C' ||
            bankDetail['accountType'] === 'checking'
          ) {
            this.enrollAccountType.controls['bankType']?.setValue('CHECKING');
            this.accountType = 'CHECKING';
          } else {
            this.enrollAccountType.controls['bankType']?.setValue('SAVING');
            this.accountType = 'SAVING';
          }
          this.checkForPrefillData(bankDetail);
          this.storeBankAccount = bankDetail['bankAccount'];
        });
    } else {
      this.enrollAccountType.controls['bankType']?.setValue('CHECKING');
      this.accountType = this.enrollAccountType.controls['bankType']?.value;
    }
  }

  private setImpNotice() {
    if(this.isDeductionDateDisabledPayPlan){
      this.importantText = 'Changing your bank account now will apply to this payment and all future invoices.'
    } else if(this.company === 'TW' || this.company === 'ACIC' || this.policyId.length === 6){      
      this.importantText = 'Changing the monthly deduction date may change the amount of your future payments.';
    } else if(this.billedInvoice){
      this.importantText = 'Changing your deduction date and/or bank account now will apply beginning with your next invoice.';      
    } else {
      this.importantText = 'Changing your deduction date and/or bank account now will apply to this payment and all future invoices.'
    }
    this.importantAchEftText = 'Please note that we can’t accept <b>Cash App or Chime</b> for payments (ACH/EFT). If you’re paying from a <b>credit union, use your routing and account number</b>—not your member ID.'
  }

  private mapDeductionDate(options: any[]) {
    this.deductionDateOptions = options.map(opt => ({
      label: opt,
      disabled: false
    }))
    if (this.isAcmic)
      this.deductionDateOptions.unshift({ label: 'Select', disabled: true });
  }

  matchValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const accountNumControl = control.get('enrollInEft_accountNumber');
    const confirmAccountNumControl = control.get('enrollInEft_confirmAccountNumber');

    if (!accountNumControl || !confirmAccountNumControl) return null;

    if (!(accountNumControl.dirty || accountNumControl.touched)
      || !(confirmAccountNumControl.dirty || confirmAccountNumControl.touched))
      return null;

    const accountNum = accountNumControl.value;
    const confirmAccountNum = confirmAccountNumControl.value;
    if (accountNum && confirmAccountNum && accountNum !== confirmAccountNum) {
      this.setError('enrollInEft_accountNumber', 'notMatch');
      this.setError('enrollInEft_confirmAccountNumber', 'notMatch');
      return { notMatch: true };
    }
    this.removeError('enrollInEft_accountNumber', "notMatch");
    this.removeError('enrollInEft_confirmAccountNumber', "notMatch")
    return null;
  }


  setError(control: string, key: string) {
    const errors = this.enrollInEft.controls[control].errors ?? {};
    errors[key] = true;
    this.enrollInEft.controls[control].setErrors(errors)
  }

  removeError(control: string, key: string) {
    const errors = this.enrollInEft.controls[control].errors;
    if (!errors) return;

    delete errors[key];
    this.enrollInEft.controls[control].setErrors(Object.keys(errors).length ? errors : null);
  }
}
